import { ChatSource } from "@mirage/mosaics/Chat/types";
import { getSourceUUID } from "@mirage/shared/compose/compose-session";

/**
 * Merges and deduplicates an array of ChatSource objects by their UUIDs.
 * If a source with the same UUID appears in both arrays, the one from manuallyAddedSources takes precedence.
 * @param hydratedSources - Array of sources from hydration
 * @param manuallyAddedSources - Array of manually added sources
 * @returns Array of deduplicated ChatSource objects
 */
export function mergeAndDeduplicateSources(
  hydratedSources: ChatSource[],
  manuallyAddedSources: ChatSource[],
): ChatSource[] {
  // Create a Map to store sources by UUID
  const sourcesByUUID = new Map<string, ChatSource>();

  // First add all hydrated sources
  for (const source of hydratedSources) {
    const uuid = getSourceUUID(source);
    if (uuid) {
      sourcesByUUID.set(uuid, source);
    }
  }

  // Then add manually added sources, which will override any duplicates
  for (const source of manuallyAddedSources) {
    const uuid = getSourceUUID(source);
    if (uuid) {
      sourcesByUUID.set(uuid, source);
    }
  }

  // Convert the Map values back to an array
  return Array.from(sourcesByUUID.values());
}
